import { GridComparatorFn, GridSortDirection } from "@mui/x-data-grid";

export const ClaimsTableWidth = {
  // Width of the grid's selection column, mirrored here so the totals row lines up with the cells
  // above it once the column is shown.
  selection: 50,
  caseNumber: 270,
  legalBasis: 140,
  srvOrderNumber: 100,
  currentSaldo: 150,
  disputedAmount: 150,
};

export function nullsLastNumberComparator(direction: GridSortDirection): GridComparatorFn<number | null> {
  const factor = direction === "desc" ? -1 : 1;
  return (a, b) => {
    if (a == null || b == null) {
      return a == null ? (b == null ? 0 : 1) : -1;
    }
    return factor * (a - b);
  };
}
